import { Injectable } from '@angular/core';
import { HcrService } from './hcr-service.service';
import { DateHelper } from '../shared/helpers/date-helper';
import { UserConfirmService } from './user-confirm.service';
import { MainLayoutService } from '../layout/services/main-layout.service';
import { DebugLogService } from './debug-log.service';

@Injectable({
  providedIn: 'root'
})
export class HpcBhpService {

  constructor(private hcrService: HcrService,
    private confirm: UserConfirmService,
    private mainlayout: MainLayoutService,
    private logger: DebugLogService
  ) {


  }
  async getToken() {
    var ret = await this.hcrService.sendMsg({
      Call: 'GetBhpApiToken',
      Args: null
    })
    if (ret.Successed) {
      return ret.Returns.Data as string;
    }
    return '';
  }
  private async getQueryData(): Promise<queryData> {
    this.mainlayout.showLoader();
    try {
      var token = await this.getToken();
      var vApi = this.hcrService.VisionApi;
      var hospId = (await vApi.GetHospID()).Data;
      var samId = (await vApi.GetCardNoSAM()).Data;
      //// debug data
      // return {
      //   "token": token,
      //   "agree": true,
      //   "person": {
      //     "hospId": hospId,
      //     "samId": samId,
      //     "cardId": '900000001416', //cardId,
      //     "birth": '0300101',//DateHelper.getROCDateString(patient.Birth).padStart(7,'0'),
      //     "pid": 'S88868670A',//patient.CId,
      //     "registerPrevent": Array(126).fill('0').map(x => '0').join() //rpStr
      //   }
      // }
      var cardId = (await vApi.GetCardNoHC()).Data;
      var patient = (await vApi.GetBasicData()).Data;

      var rp = (await vApi.GetRegisterPrevent()).Data;
      var rpStr = ''
      var rpSets = [rp.Set1, rp.Set2, rp.Set3, rp.Set4, rp.Set5, rp.Set6]
      for (let r of rpSets) {
        rpStr += r.HealthCareFlag.padEnd(2, '\0');
        rpStr += DateHelper.getROCDateString(new Date(r.ExamDate)).padStart(7, '0');
        rpStr += r.ClinicCode.padEnd(10, '\0');
        rpStr += r.ProjectCode.padEnd(2, '\0');
      }

      var data = {
        "token": token,
        "agree": true,
        "person": {
          "hospId": hospId,
          "samId": samId,
          "cardId": cardId,
          "birth": DateHelper.getROCDateString(new Date( patient.Birth)).padStart(7, '0'),
          "pid": patient.CId,
          "registerPrevent": rpStr
        }
      }
      return data;
    } catch(e) {
      console.log(e)
      this.logger.ClientLog2('Error', false, () => '成建BC肝查詢取得患者資料失敗 ' + JSON.stringify(e));
    } finally {
      this.mainlayout.hideLoader()
    }
  }
  private async checkHCCard() {
    var i = (await this.hcrService.VisionApi.GetCardStatusHC()).StatusCode == 0;
    if (!i) {
      await this.confirm.showAlert('未置入健保卡', '請插入健保卡');
      return false;
    }
    return true;
  }
  async query肝() {
    if (!await this.checkHCCard()) {
      return;
    }
    var data = await this.getQueryData()
    data.agree = false;
    var ret = await this.queryAll(data);
    if (ret.statusBC肝 == '04' || ret.statusBC肝 == '94') {
      var cf = await this.confirm.showConfirm({
        title: '知情同意',
        msg: ret.desc,
        width: 600
      });
      if (cf) {
        data.agree = true;
        ret = await this.queryAll(data);
      }
    }
    await this.confirm.showAlert('查詢結果', ret.desc, { width: 600 });
  }

  async query成() {
    if (!await this.checkHCCard()) {
      return;
    }
    var data = await this.getQueryData()
    data.agree = false;
    var ret = await this.queryAll(data);
    if (ret.status成建 == '04' || ret.status成建 == '94') {
      var cf = await this.confirm.showConfirm({
        title: '知情同意',
        msg: ret.desc,
        width: 600
      });
      if (cf) {
        data.agree = true;
        ret = await this.queryAll(data);
      }
    }
    await this.confirm.showAlert('查詢結果', ret.desc, { width: 600 });
  }

  async query成肝() {
    if (!await this.checkHCCard()) {
      return;
    }
    var data = await this.getQueryData()
    data.agree = false;
    var ret = await this.queryAll(data);
    if (ret.status成建 == '04' || ret.status成建 == '94' || ret.statusBC肝 == '04' || ret.statusBC肝 == '94') {
      var cf = await this.confirm.showConfirm({
        title: '知情同意',
        msg: ret.desc,
        width: 600
      });
      if (cf) {
        data.agree = true;
        ret = await this.queryAll(data);
      }
    }
    var cRet = await this.confirm.showConfirm({
      title: '查詢結果',
      msg: ret.desc,
      width: 600,
      hideYes: true,
      textNo: '關閉',
      customBtnStart: [{
        text: 'BC肝篩檢登記',
        return: 'BCReg',
        //btnCls: ret.statusBC肝 == '01' || ret.statusBC肝 == '91' ? 'border-animate vis-btn-secondary' : ''
      }, {
        text: 'BC肝篩檢登記取消',
        return: 'BCCancel',
        //btnCls: 'red'
      }],
    });
    if (cRet == 'BCReg') {
      await this.registBCLiver();
    } else if (cRet == 'BCCancel') {
      await this.cancelRegistBCLiver();
    }
  }
  /** 成人健檢資格查詢 */
  private async queryAll(data: queryData) {
    try {
      this.mainlayout.showLoader()
      var url = 'https://apcvpn.hpa.gov.tw/bhpapi/api/All/Valid'
      var result = await this.hcrService.SendFromUrl(url, JSON.stringify(data), 'application/json', 'utf-8', {});
      if (result.Successed) {
        console.log(result.Returns);
        var bhpResult = JSON.parse(result.Returns) as hpabhpData;
        return new hpabhpResult(bhpResult);
      } else {
        console.log(result.Returns);
        return null;
      }
    } catch (e) {
      console.log(e)
      this.logger.ClientLog2('Error', false, () => '成建BC肝查詢失敗 ' + JSON.stringify(e));

    } finally {
      this.mainlayout.hideLoader()
    }
  }
  /** B、C 肝篩檢登記 */
  async registBCLiver() {
    if (!await this.checkHCCard()) {
      return;
    }
    var url = 'https://apcvpn.hpa.gov.tw/bhpapi/api/BcLiver/Register'
    var data = await this.getQueryData();
    try {
      this.mainlayout.showLoader();
      var result = await this.hcrService.SendFromUrl(url, JSON.stringify(data), 'application/json', 'utf-8', {});
      this.mainlayout.hideLoader()
      if (result.Successed) {
        var bhpResult = JSON.parse(result.Returns) as hpabhpData;
        var r = new hpabhpRegistResult(bhpResult);
        await this.confirm.showAlert('操作結果', r.desc);
      } else {
        console.log(result.Returns);
        await this.confirm.showAlert('操作失敗', result.Returns);
        return null;
      }
    }
    catch (e) {
      this.logger.ClientLog2('Error', false, () => 'B、C 肝篩檢登記 ' + JSON.stringify(e));
    } finally {
      this.mainlayout.hideLoader();
    }
  }
  /** B、C 肝篩檢登記取消 */
  async cancelRegistBCLiver() {
    if (!await this.checkHCCard()) {
      return;
    }
    try {
      this.mainlayout.showLoader();
      var url = 'https://apcvpn.hpa.gov.tw/bhpapi/api/BcLiver/Cancel'
      var data = await this.getQueryData();
      var result = await this.hcrService.SendFromUrl(url, JSON.stringify(data), 'application/json', 'utf-8', {});
      this.mainlayout.hideLoader()
      if (result.Successed) {
        var bhpResult = JSON.parse(result.Returns) as hpabhpData;
        var r = new hpabhpRegistResult(bhpResult);
        await this.confirm.showAlert('操作結果', r.desc);
      } else {
        console.log(result.Returns);
        await this.confirm.showAlert('操作失敗', result.Returns);
        return null;
      }

    }
    catch (e) {
      this.logger.ClientLog2('Error', false, () => 'B、C 肝篩檢登記取消 ' + JSON.stringify(e));
    } finally {
      this.mainlayout.hideLoader();
    }
  }
}

interface queryData {
  token: string,
  agree: boolean,
  person: {
    hospId: string,
    samId: string,
    cardId: string,
    birth: string,
    pid: string,
    registerPrevent: string,
  }
}
export interface hpabhpData {
  status: boolean;
  code: string;
  description: string;
}
export class hpabhpResult {
  desc: string;
  /** 00 = 未查 B、C 肝炎
01 = 未做過

02 = 年齡不符

03 = 已做過

04 =已做過並徵詢是否同意查前次篩檢機構

第 1 碼為 9 表示健保卡預防保健紀錄任一組包含空白或特殊字元導致無法完整判斷：

90 = 未查 B、C 肝炎

91 = 未做過

92 = 年齡不符

93 = 已做過

94 =已做過並徵詢是否同意查前次篩檢機構
    *  */
  statusBC肝: string;
  /**
   00 = 未查成人預防保健

  01 = 未做過

  02 = 年齡不符

  03 = 已做過

  04 = 已做過並徵詢是否同意查前次  篩檢機構

  第 3 碼為 9 表示健保卡預防保健紀錄任一組包含空白或特殊字元導致無法完整判斷：

  90 = 未查成人預防保健

  91 = 未做過

  92 = 年齡不符

  93 = 已做過

  94 =已做過並徵詢是否同意查前次篩檢機構

   */
  status成建: string;
  /**
   * 第 5-6 碼表示身分別：
   * 
    00 = 一般身分

    01 = 原住民
   */
  身分: string;
  constructor(data: hpabhpData) {
    this.desc = data.description;
    var code = data.code;
    this.statusBC肝 = code.substring(0, 2);
    this.status成建 = code.substring(2, 4);
    this.身分 = code.substring(5, 7);
  }
}

export class hpabhpRegistResult {
  desc: string;

  /**
    登記結果狀態

    12 登記失敗，年齡不符合 B、C 肝篩檢資格。

    13 登記失敗，已做過 B、C 肝篩檢。
    
    11 登記成功。

    22 取消失敗，未在院所登記過 B、C 肝篩檢。

    21 取消成功。

    23 取消失敗，作業已逾期
   */
  result: string;
  constructor(data: hpabhpData) {
    this.desc = data.description;
    var code = data.code;
    this.result = code.substring(0, 2);
  }
}